import { render } from "./organisation-persons.vue?vue&type=template&id=78d1f2fa&scoped=true"
import script from "./organisation-persons.vue?vue&type=script&lang=js"
export * from "./organisation-persons.vue?vue&type=script&lang=js"

import "./organisation-persons.vue?vue&type=style&index=0&id=78d1f2fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d1f2fa"]])

export default __exports__